import { FC, ChangeEvent } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { TextFieldBasic } from '@blueprint/ui';
import { FiltersLabel } from './Filters.styles';
import { updateFilter, keywordsSelector } from '@zoopla/redux-reducer-filters';
import styled from '@emotion/styled';
import { css } from '@emotion/react';

const TipText = styled('p')(
    ({ theme }) => css`
        margin: ${theme.spacing['8px']} 0 0 0;
        line-height: ${theme.type.lineHeight};
        font-size: ${theme.type.small};
        color: ${theme.colors['text-placeholder']};
    `
);

export const Keywords: FC = () => {
    const reduxDispatch = useDispatch();

    const {
        selectedValue: keywords,
        placeholder,
        tip,
        label
    } = useSelector(keywordsSelector);

    const onTextInputChange = (evt: ChangeEvent<HTMLInputElement>) => {
        reduxDispatch(updateFilter('keywords', evt.currentTarget.value));
    };

    return (
        <>
            <FiltersLabel htmlFor="modal-keywords-filter">{label}</FiltersLabel>
            <TextFieldBasic
                id="modal-keywords-filter"
                placeholder={placeholder}
                onChange={onTextInputChange}
                value={keywords}
                data-testid="modal-keywords-filter"
            />
            <TipText data-testid="keywords-filter-tip">{tip}</TipText>
        </>
    );
};
